export default {
  主页面标题: "采购申请管理",
  申请采购按钮: "申请采购",
  草稿: "草稿",
  审批中: "审批中",
  已驳回: "已驳回",
  已通过: "已通过",
  采购申请状态: "采购申请状态",
  表单编号: "表单编号",
  PR编号: "PR编号",
  物料: "物料",
  供应商: "供应商",
  申请表类型: "申请表类型",
  采购类别: "采购类别",
  工厂: "工厂",
  二级采购类别: "二级采购类别",
  三级采购类别: "三级采购类别",
  采购负责人: "采购负责人",
  PO编号: "PO编号",
  采购项数: "采购项数",
  物料类别: "物料类别",
  物料编号: "物料编号",
  物料名称: "物料名称",
  产品名称: "产品名称",
  采购申请总金额HKD: "采购申请总金额（HKD）",
  要求完成日期: "要求完成日期",
  要求到货日期: "要求到货日期",
  申请人: "申请人",
  申请时间: "申请时间",
  操作: "操作",
  搜索物料编号名称占位符: "请输入物料编号/物料名称",
  搜索供应商编号名称占位符: "请输入供应商编号/供应商名称",
  编辑: "编辑",
  查看: "查看",
  重新提交: "重新提交",
  删除: "删除",
  采购申请表: "采购申请表",
  下一步: "下一步",
  采购类型: "采购类型",
  是否有物料编号: "是否有物料编号",
  申请信息: "申请信息",
  请选择: "请选择",
  请选择申请部门: "请选择申请部门",
  暂存: "暂存",
  提交: "提交",
  关闭: "关闭",
  提交成功: "提交成功",
  请检查表单填写是否完整: "请检查表单填写是否完整",
  请先生成PR编号: "请先生成PR编号",
  订单确认: "订单确认",
  审批通过: "审批通过",
  表单类型信息缺失无法执行审批: "表单类型信息缺失，无法执行审批",
  未配置采购人员审核策略: "未配置对应表单类型的采购人员审核策略，无法执行审批",
  未配置财务人员初审策略: "未配置对应表单类型的财务人员初审策略，无法执行审批",
  请完善寻源结果: "请完善寻源结果",
  生成PR: "生成PR",
  确认: "确认",
  确认生成PR编号吗: "确认生成PR编号吗？",
  寻源结果: "寻源结果",
  申请采购物品明细: "申请采购物品明细",
  采购组: "采购组",
  是否指定建议供应商: "是否指定/建议供应商",
  指定建议供应商名称: "指定/建议供应商名称",
  指定建议供应商原因: "指定/建议供应商原因",
  是否需要合同: "是否需要合同",
  指定建议供应商相关附件: "指定/建议供应商的相关附件",
  寻源结果说明: "寻源结果说明",
  合同文件: "合同文件",
  供应商编号: "供应商编号",
  供应商名称: "供应商名称",
  报价单: "报价单",
  继续添加: "继续添加",
  请输入供应商名称: "请输入供应商名称",
  获取物料: "获取物料",
  序号: "序号",
  添加: "添加",
  分类: "分类",
  申请数量: "申请数量",
  单位: "单位",
  每组单位: "每组单位",
  单价HKD: "单价 HKD",
  年采购均价: "年采购均价",
  申请总金额HKD: "申请总金额HKD",
  采购说明: "采购说明",
  采购原因: "采购原因",
  安全库存: "安全库存",
  优先采购: "优先采购",
  上传附件: "上传附件",
  固定资产信息: "固定资产信息",
  是否创建固定资产编号: "是否创建固定资产编号",
  固定资产编号: "固定资产编号",
  预算信息: "预算信息",
  申请人提供文件: "申请人提供文件",
  已批准预算类型: "已批准预算类型",
  项目编号: "项目编号",
  原因说明: "原因说明",
  预算金额币种: "预算金额/币种",
  预算金额HKD: "预算金额 HKD",
  申请总金额币种: "申请总金额/币种",
  采购委员会会议纪要文件: "采购委员会会议纪要文件",
  计划书URS配置清单第一次报价等文件: "计划书/URS/配置清单/第一次报价等文件",
  实地考察报告用户要求符合度评估文件: "实地考察报告/用户要求符合度评估文件",
  供应商比较总结商务标评分表: "供应商比较总结/商务标评分表",
  合并评分表: "合并评分表",
  投资分析: "投资分析",
  特别要求: "特别要求",
  是否现有生产物料: "是否现有生产物料",
  相关产品名称: "相关产品名称",
  关联项目编号: "关联项目编号",
  关联项目名称: "关联项目名称",
  供应商信息: "供应商信息",
  数量单位: "数量/单位",
  单价币种: "单价/币种",
  总价币种: "总价/币种",
  备注: "备注",
  药典标准: "药典/标准",
  指定建议的药典或质量标准如有: "指定/建议的药典或质量标准（如有）",
  批次要求: "批次要求",
  是否指定供应商: "是否指定供应商",
  指定建议供应商COA: "指定/建议供应商COA",
  其他附件: "其他附件",
  RLD中文通用名称: "RLD中文通用名称",
  RLD英文通用名称: "RLD英文通用名称",
  RLD中文商品名称: "RLD中文商品名称",
  RLD英文商品名称: "RLD英文商品名称",
  请附上指定建议的RLD说明资料: "请附上指定/建议的RLD说明资料",
  上市国家或地区: "上市国家或地区",
  主要成分: "主要成分",
  规格: "规格",
  剂型: "剂型",
  包装规格: "包装规格",
  需求数量: "需求数量",
  要求到货时间: "要求到货时间",
  效期要求: "效期要求",
  从供应商库选择: "从供应商库选择",
  搜索物料: "搜索物料",
  单价: "单价",
  单价单位: "单价单位",
  费用归属部门: "费用归属部门",
  成本中心: "成本中心",
  会计科目: "会计科目",
  物料组: "物料组",
  期望到货日期: "期望到货日期",
  是否紧急采购: "是否紧急采购",
  单一: "单一",
  多个: "多个",
  指定供应商及型号: "指定供应商及型号",
  指定原因: "指定原因",
  采购物品描述: "采购物品描述",
  采购目的: "采购目的",
  请选择物料: "请选择物料",
  请输入申请数量: "请输入申请数量",
  请选择单位: "请选择单位",
  请选择物料组: "请选择物料组",
  请选择日期: "请选择日期",
  请输入描述: "请输入描述",
  请选择成本中心: "请选择成本中心",
  请选择币种: "请选择币种",
  请选择采购组: "请选择采购组",
  请输入关联项目编号: "请输入关联项目编号",
  请输入关联项目名称: "请输入关联项目名称",
  请选择供应商: "请选择供应商",
  二级物料类别: "二级物料类别",
  申请金额范围: "申请金额范围",
  自动计算: "自动计算",
  总金额: "总金额",
  请输入固定资产编号: "请输入固定资产编号",
  请输入寻源结果: "请输入寻源结果",
  请输入包装规格: "请输入包装规格",
  请输入预算金额: "请输入预算金额",
  请输入申请总金额: "请输入申请总金额",
  请选择是否指定建议供应商: "请选择是否指定/建议供应商",
  最后PO单价: "最后PO单价",
  新旧价格变动: "新旧价格变动",
  最后PO供应商编号: "最后PO供应商编号",
  最后PO供应商名称: "最后PO供应商名称",
  最后PO币种: "最后PO币种",
  上次PO价格数量单位: "上次PO价格数量单位",
  最后PO数量: "最后PO数量",
  现有库存: "现有库存",
  描述: "描述",
  请选择是否现有生产物料: "请选择是否现有生产物料",
  请选择要求完成日期: "请选择要求完成日期",
  请选择费用归属部门: "请选择费用归属部门",
  请选择会计科目: "请选择会计科目",
  请选择是否紧急采购: "请选择是否紧急采购",
};
